if(!customElements.get('read-more')) {
  class ComponentReadMore extends HTMLElement {
    constructor() {
      super();
      this.moreButton = this.querySelector('.read-more');
      this.lessButton = this.querySelector('.read-less');
      this.moreContent = this.querySelector('.more-content');
      this.truncContent = this.querySelector('.trunced');
     
      this.moreButton.addEventListener('click', ()=> {
        this.moreContent.classList.remove('hide');
        this.truncContent.classList.add('hide');
        this.lessButton.classList.remove('hide');
        this.moreButton.classList.add('hide');

      });

      this.lessButton.addEventListener('click', ()=> {
        this.moreContent.classList.add('hide');
        this.truncContent.classList.remove('hide');
        this.lessButton.classList.add('hide');
        this.moreButton.classList.remove('hide');

      });

    }

   

  }
  customElements.define('read-more', ComponentReadMore);
}